if (document.getElementById('vue-sectors')) {
	new Vue({
		mixins: [baseMixin, eventHubMixin, apiMixin],
		el: '#vue-sectors',
		data: {
			sectors: []
		},
		mounted() {
			this.getSectors()
		},
		methods: {
			getSectors() {
				this.get('wp/v2/wpbb_job_industry')
					.then((response) => {
						this.sectors = response.data
						// console.log(response);
					})
					.catch((error) => {
						// console.log(error)
					})
			},
			escape(string) {
				return string.replace(/&amp;/g, '&')
			}
		}
	})
}
